module.exports = __webpack_public_path__ + "img/symbol_1.15f03030.png";